import {
  GET_SUPERVISORS,
} from 'constants/supervisors';

export default (state = [], action) => {
    switch (action.type) {
    case `${GET_SUPERVISORS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
